import { MenuItem, NavBadge } from './menu.model';

export interface SuperAdminNavNode {
  /** Sidebar section title key; set on top-level nodes only. */
  section?: string;
  label: string;
  icon?: string;
  link?: string;
  permission?: string | string[];
  badge?: NavBadge;
  /** Shown only while the platform CRM switch is on. */
  requiresCrm?: boolean;
  children?: SuperAdminNavNode[];
}

export const SUPER_ADMIN_NAV: SuperAdminNavNode[] = [
  {
    label: 'SUPER_ADMIN.MENU.HOME',
    icon: 'isax isax-home-2',
    link: '/home',
    permission: 'super-admin.academies.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.TODAY',
    icon: 'isax isax-element-3',
    link: '/crm/today',
    permission: ['super-admin.crm.leads.view', 'super-admin.crm.customers.view', 'super-admin.crm.financial.view'],
    badge: 'crmAlerts',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.LEADS',
    icon: 'isax isax-user-search',
    link: '/crm/leads',
    permission: 'super-admin.crm.leads.view',
    badge: 'crmLeads',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.CUSTOMERS',
    icon: 'isax isax-profile-2user',
    link: '/crm/customers',
    permission: 'super-admin.crm.customers.view',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.PAYMENTS',
    icon: 'isax isax-money-recive',
    link: '/crm/payments',
    permission: 'super-admin.crm.financial.view',
    badge: 'crmPayments',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.REPORTS',
    icon: 'isax isax-chart-2',
    link: '/crm/reports',
    permission: ['super-admin.crm.leads.view', 'super-admin.crm.financial.view'],
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.SERVICES',
    icon: 'isax isax-box',
    link: '/crm/services',
    permission: 'super-admin.crm.services.view',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CRM',
    label: 'CRM.MENU.SETTINGS',
    icon: 'isax isax-setting-4',
    link: '/crm/settings',
    permission: 'super-admin.crm.settings.manage',
    requiresCrm: true,
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_ACADEMIES',
    label: 'SUPER_ADMIN.MENU.ACADEMIES',
    icon: 'isax isax-category',
    link: '/academies',
    permission: 'super-admin.academies.view',
    badge: 'renewals',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_ACADEMIES',
    label: 'SUPER_ADMIN.MENU.USERS',
    icon: 'isax isax-profile-2user',
    link: '/users',
    permission: 'super-admin.people.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_ACADEMIES',
    label: 'SUPER_ADMIN.MENU.SUBSCRIPTIONS',
    icon: 'isax isax-card',
    link: '/subscriptions',
    permission: 'super-admin.subscriptions.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_ACADEMIES',
    label: 'SUPER_ADMIN.MENU.INVOICES',
    icon: 'isax isax-receipt',
    link: '/invoices',
    permission: 'super-admin.invoices.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_ACADEMIES',
    label: 'SUPER_ADMIN.MENU.ACADEMY_NOTES',
    icon: 'isax isax-note-text',
    link: '/academy-notes',
    permission: 'super-admin.academy-notes.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_COMMUNICATION',
    label: 'SUPER_ADMIN.MENU.SUPPORT',
    icon: 'isax isax-message-question',
    badge: 'support',
    children: [
      { label: 'SUPER_ADMIN.MENU.SUPPORT_INBOX', link: '/support', permission: 'super-admin.support.view' },
      { label: 'SUPER_ADMIN.MENU.SUPPORT_SETTINGS', link: '/support/settings', permission: 'super-admin.support.manage' },
    ],
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_COMMUNICATION',
    label: 'SUPER_ADMIN.MENU.INBOX',
    icon: 'isax isax-sms',
    link: '/inbox',
    permission: 'super-admin.inbox.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_COMMUNICATION',
    label: 'SUPER_ADMIN.MENU.CUSTOM_MESSAGES',
    icon: 'isax isax-message-text',
    link: '/message-approvals',
    permission: 'super-admin.custom-messages.view',
    badge: 'approvals',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_COMMUNICATION',
    label: 'SUPER_ADMIN.MENU.EMAIL_LOGS',
    icon: 'isax isax-sms-tracking',
    link: '/email-logs',
    permission: 'super-admin.email-logs.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_REPORTS',
    label: 'SUPER_ADMIN.MENU.REPORTS',
    icon: 'isax isax-document-text',
    children: [
      { label: 'SUPER_ADMIN.MENU.COMPREHENSIVE_ACADEMIES_REPORT', link: '/reports/academies', permission: 'super-admin.reports.academies.view' },
      { label: 'SUPER_ADMIN.MENU.OTP_REPORT', link: '/reports/verification-codes', permission: 'super-admin.reports.otp.view' },
      { label: 'SUPER_ADMIN.MENU.PAYMENT_LINK_REPORT', link: '/reports/payment-links', permission: 'super-admin.reports.payment-links.view' },
      { label: 'SUPER_ADMIN.MENU.COMMISSION_REPORT', link: '/reports/commissions', permission: 'super-admin.reports.commissions.view' },
    ],
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CONTENT',
    label: 'SUPER_ADMIN.MENU.PUBLISHING',
    icon: 'isax isax-note-1',
    children: [
      { label: 'SUPER_ADMIN.MENU.NEWS', link: '/publishing/news', permission: 'super-admin.publishing.view' },
      { label: 'SUPER_ADMIN.MENU.SERVICES', link: '/publishing/services', permission: 'super-admin.publishing.view' },
    ],
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_CONTENT',
    label: 'SUPER_ADMIN.MENU.WEBSITE',
    icon: 'isax isax-text-italic4',
    children: [
      { label: 'SUPER_ADMIN.MENU.SITE_SETTINGS', link: '/website/settings', permission: 'super-admin.content.view' },
      { label: 'SUPER_ADMIN.MENU.TERMS', link: '/website/terms', permission: 'super-admin.content.view' },
      { label: 'SUPER_ADMIN.MENU.TESTIMONIALS', link: '/website/testimonials', permission: 'super-admin.content.view' },
      { label: 'SUPER_ADMIN.MENU.FAQS', link: '/website/faqs', permission: 'super-admin.content.view' },
      { label: 'SUPER_ADMIN.MENU.PARTNERS', link: '/website/partners', permission: 'super-admin.content.view' },
    ],
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.PLATFORM_SETTINGS',
    icon: 'isax isax-setting-2',
    link: '/settings/platform',
    permission: 'super-admin.settings.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.EVALUATION',
    icon: 'isax isax-note-text4',
    link: '/evaluation',
    permission: 'super-admin.evaluation.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.PLATFORM_RBAC',
    icon: 'isax isax-security-user',
    link: '/staff-permissions',
    permission: ['super-admin.staff.view', 'super-admin.roles.view'],
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.PAYMENT_LINKS',
    icon: 'isax isax-link',
    link: '/settings/payment-links',
    permission: 'super-admin.payment-links-settings.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.COMMISSIONS',
    icon: 'isax isax-percentage-square',
    link: '/settings/commissions',
    permission: 'super-admin.commission-settings.view',
  },
  {
    section: 'SUPER_ADMIN.MENU.SECTION_SETTINGS',
    label: 'SUPER_ADMIN.MENU.AUDIT_LOGS',
    icon: 'isax isax-document-text-1',
    link: '/activity-log',
    permission: 'super-admin.audit-logs.view',
  },
];

export function superAdminMenuItems(): MenuItem[] {
  const items: MenuItem[] = [];
  let currentSection: string | undefined;
  for (const node of SUPER_ADMIN_NAV) {
    if (node.section && node.section !== currentSection) {
      currentSection = node.section;
      items.push({ label: node.section, isTitle: true });
    }
    items.push({ ...toMenuItem(node), section: node.section, requiresCrm: node.requiresCrm });
  }
  return items;
}

export const SUPER_ADMIN_FORBIDDEN_ROUTE = '/forbidden';

/**
 * The first page this user may open. Pass `crmEnabled: false` while the CRM switch is off so CRM
 * pages are skipped: the CRM guard sends users here, and a CRM page would send them back (PF-0144).
 */
export function resolveSuperAdminLandingRoute(
  permissions: readonly string[] | null | undefined,
  preferredRoute?: string | null,
  options: { crmEnabled?: boolean } = {}
): string {
  const permissionSet = new Set((permissions || []).filter(Boolean));
  const accessibleNodes = flattenNavNodes(SUPER_ADMIN_NAV)
    .filter((node): node is SuperAdminNavNode & { link: string } => Boolean(node.link))
    .filter((node) => options.crmEnabled !== false || !node.requiresCrm)
    .filter((node) => hasRequiredPermission(permissionSet, node.permission));

  const normalizedPreferredRoute = normalizeSuperAdminRoute(preferredRoute);
  if (normalizedPreferredRoute) {
    const preferredNode = accessibleNodes.find((node) => normalizedPreferredRoute === node.link
      || normalizedPreferredRoute.startsWith(`${node.link}/`));
    if (preferredNode) {
      return normalizedPreferredRoute;
    }
  }

  return accessibleNodes[0]?.link || SUPER_ADMIN_FORBIDDEN_ROUTE;
}

function toMenuItem(node: SuperAdminNavNode): MenuItem {
  return {
    label: node.label,
    icon: node.icon,
    link: node.link,
    permission: node.permission || 'super-admin.access',
    badge: node.badge,
    subItems: node.children?.map((child) => toMenuItem(child)),
  };
}

function flattenNavNodes(nodes: readonly SuperAdminNavNode[]): SuperAdminNavNode[] {
  return nodes.flatMap((node) => node.children?.length
    ? flattenNavNodes(node.children)
    : [node]);
}

function hasRequiredPermission(
  permissions: ReadonlySet<string>,
  required: string | string[] | undefined
): boolean {
  if (permissions.has('*')) {
    return true;
  }

  const requiredPermissions = Array.isArray(required) ? required : [required];
  return requiredPermissions
    .filter((permission): permission is string => Boolean(permission))
    .some((permission) => permissions.has(permission));
}

function normalizeSuperAdminRoute(route: string | null | undefined): string | null {
  if (!route) {
    return null;
  }

  const path = route.split(/[?#]/)[0].replace(/^\/super-admin(?=\/|$)/, '') || '/';
  return path.startsWith('/') ? path : `/${path}`;
}
